import {useEffect, useState} from 'react'

export function useDetectInputDevices() {
  const [hasMouse, setHasMouse] = useState(false)
  const [hasTouch, setHasTouch] = useState(false)
  useEffect(() => {
    if (matchMedia('(any-pointer: fine)').matches || matchMedia('(any-hover: hover)').matches) {
      setHasMouse(true)
    }
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
      setHasTouch(true)
    }
  }, [])

  return {hasMouse, hasTouch}
}
